var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 116,
    viewBox: "0 0 559 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 325.332,
    y: -256.668,
    width: 353.594,
    height: 353.594,
    transform: "rotate(45 325.332 -256.668)",
    stroke: "#F8F8F8",
    strokeWidth: 1.86667
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1.31993,
    width: 353.594,
    height: 353.594,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 569.188 60.5003)",
    stroke: "#F8F8F8",
    strokeWidth: 1.86667
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 314.855,
    y: -120.522,
    width: 353.594,
    height: 353.594,
    transform: "rotate(45 314.855 -120.522)",
    stroke: "#F8F8F8",
    strokeWidth: 1.86667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares);
export default __webpack_public_path__ + "static/media/squares.6eb4052b57055e9803e532fef1d87eb7.svg";
export { ForwardRef as ReactComponent };